import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useSiteCopySelector from 'components/useSiteCopySelector';
import _get from 'lodash/get';
import { toSentenceCase } from 'utils/stringUtils';

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
  },
  label: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.bgColor.default,
    },
  },
}));

const CustomResourceButton = ({ isOpen, setIsOpen }) => {
  const classes = useStyles();
  const [assessmentSiteCopy] = useSiteCopySelector(['assessment']);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  // return null for now in case the want it add it back again
  return null;

  // eslint-disable-next-line no-unreachable
  return (
    <div
      className={classes.buttonWrapper}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyPress={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
    >
      <Typography className={classes.label} variant="overline">
        {toSentenceCase(
          _get(
            assessmentSiteCopy,
            isOpen ? 'pageCopy.collapseSources' : 'pageCopy.expandSources',
          ),
        )}
      </Typography>
    </div>
  );
};

CustomResourceButton.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export default CustomResourceButton;
